"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeInput = void 0;

var _styledComponents = require("@rebass/forms/styled-components");

var _react = require("react");

var _atoms = require("../atoms");

var _hooks = require("../hooks");

var _jsxRuntime = require("react/jsx-runtime");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SubscribeInput = function SubscribeInput(_ref) {
  var listId = _ref.listId,
      tag = _ref.tag;
  var subscribe = (0, _hooks.useSubscribe)(listId, tag);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      emailAddress = _useState2[0],
      setEmailAddress = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSubscribed = _useState4[0],
      setSubscribed = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isError = _useState6[0],
      setError = _useState6[1];

  var handleSubscribe = function handleSubscribe(event) {
    event.preventDefault();
    setSubscribed(false);
    setError(false);
    subscribe(emailAddress).then(function () {
      return setSubscribed(true);
    })["catch"](function () {
      return setError(true);
    });
  };

  var handleChange = function handleChange(event) {
    setSubscribed(false);
    setError(false);
    setEmailAddress(event.target.value);
  };

  return (0, _jsxRuntime.jsxs)("form", {
    onSubmit: handleSubscribe,
    style: {
      width: '100%'
    },
    children: [(0, _jsxRuntime.jsxs)(_atoms.Flex, {
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      justifyContent: {
        _: 'center',
        lg: 'flex-start'
      },
      children: [(0, _jsxRuntime.jsx)(_styledComponents.Input, {
        height: "40px",
        color: "text.footer",
        sx: {
          border: '1px solid',
          borderRight: 'none',
          borderColor: 'footer.border',
          boxShadow: 'none'
        },
        placeholder: "Email Address",
        onChange: handleChange
      }), (0, _jsxRuntime.jsx)(_atoms.Button, {
        height: "40px",
        p: "0",
        px: "14px",
        sx: {
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0'
        },
        children: "Subscribe"
      })]
    }), isSubscribed && (0, _jsxRuntime.jsx)(_atoms.Body, {
      variant: "small",
      color: "text.footer",
      mt: "10px",
      children: "Your email was added to our mailing list!"
    }), isError && (0, _jsxRuntime.jsx)(_atoms.Body, {
      variant: "small",
      color: "text.footer",
      mt: "10px",
      children: "Your email could not be added to the mailing list. You may be subscribed already."
    })]
  });
};

exports.SubscribeInput = SubscribeInput;